import classNames from 'classnames';
import Modal from '../../containers/modal.jsx';
import styles from './share-project-modal.css';
import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import Box from '../box/box.jsx';
import {closeShareProject} from '../../reducers/modals';
import {userLogined} from '../../reducers/user-state';
import {connect} from 'react-redux';
import {defineMessages, intlShape, injectIntl} from 'react-intl';
var isSending = false;
const ShareProjectModal = ({
    onCanel,
    onFileonlyChange,
    onFileContestChange,
    onFiletitleChange,
    onFileexplainChange,
    onFileabstractChange,
    onTagsChange,
    shareProject
}) => (
     <ReactModal
        isOpen
        className={classNames(styles.modalContent)}
        overlayClassName={styles.modalOverlay}
    >
             <div className={styles.released_illustration}><span>发布作品</span></div>
             <div className={styles.released_body}>
                <div className={styles.released_relbox}>
                    <p>作品名称</p>
                    <input type="text" onChange={onFiletitleChange}/>
                </div>
                <div className={styles.released_relbox}>
                    <p>作品简介</p>
                    <textarea rows="4" maxLength="140" placeholder="不超过140个字" onChange={onFileabstractChange}></textarea>
                </div>
                <div className={styles.released_relbox}>
                    <p>操作说明</p><textarea rows="4" maxLength="140" placeholder="不超过140个字" onChange={onFileexplainChange}></textarea>
                </div>
                <div className={styles.released_relbox}>
                    <label><input type="checkbox" name="isOnlysee" value="on" onChange={onFileonlyChange}/>设为私密</label>
                </div>
                 {window.scratchConfig.needContest  ?(
                    <div className={styles.released_relbox}>
                        <label><input type="checkbox" name="isContest" value="on" onChange={onFileContestChange}/>设为第{window.scratchConfig.contestNum}届赛事作品</label>
                    </div>
                ):null
                }
                <div className={classNames(styles.released_relbox ,styles.released_tags_a8I)}>
                    <p>分类标签<em>（请选择作品分类标签）</em></p>
                    <span  onClick={onTagsChange} tabIndex="0">游戏</span>
                    <span onClick={onTagsChange} tabIndex="1">动画</span>
                    <span onClick={onTagsChange} tabIndex="2">音乐</span>
                    <span onClick={onTagsChange} tabIndex="3">模拟</span>
                    <span onClick={onTagsChange} tabIndex="4">搞笑</span>
                    <span onClick={onTagsChange} tabIndex="5">故事</span>
                </div>
        
                <div className={styles.releasedButtonRow}>
                    <button type="button" className={styles.releasedOkButton}>
                        <span className={styles.buttonOutlinedButton} role="button" onClick={shareProject}>
                            <div className={styles.buttonContent}>
                                <span>发布</span>
                            </div>
                        </span>
                    </button>
                    <button className={styles.releasedNoButton} id="closeShareProject" onClick={onCanel}>
                        <span>关闭</span>
                    </button>
                </div>
            </div>
    </ReactModal>
);


ShareProjectModal.propTypes = {
    onCanel: PropTypes.func,
    shareProject: PropTypes.func,
    onTagsChange: PropTypes.func,
    onFileabstractChange: PropTypes.func,
    onFiletitleChange: PropTypes.func,
    onFileexplainChange: PropTypes.func,
    onFileContestChange: PropTypes.func,
    onFileonlyChange: PropTypes.func
}

ShareProjectModal.defaultProps = {

    title:null,
    onFileonlyChange:(e)=>{

        let val=e.target.checked;
        Filedata.fileonly = val;
    },
     onFileContestChange:(e)=>{

        let val=e.target.checked;
        Filedata.isContest = val;
    },

     onTagsChange:(e)=>{

        let idx=parseInt(e.target.tabIndex);
        if(tags[idx]==0)
        {
            e.target.style.background="#4C97FF"; 
            e.target.style.color="#fff";
            tags[idx]=1;
        }
        else
        {

            e.target.style.background="#fff"; 
            e.target.style.color="#4C97FF";
             tags[idx]=0;
        }
       
    },
    onFileabstractChange:(e)=>{

        let val=e.target.value;
        Filedata.fileabstract = val;
    },

    onFiletitleChange:(e)=>{

        let val=e.target.value;
        Filedata.filetitle = val;
    },
    onFileexplainChange:(e)=>{

        let val=e.target.value;
        Filedata.fileexplain = val;
    },

    shareProject:()=>{
        if(isSending == true)
        {
            alert("上次作品 还在发布中");
        }
        else {
            isSending = true;
            Filedata.tags ="";
            var f =0;
            for (var i = 0; i < tags.length; i++) { 
                    if(tags[i])
                    {
                        if(f!=0)
                        {
                            Filedata.tags+=',';
                        }
                        Filedata.tags+=tagst[i];
                        f =1;
                    }
            }
           const rootEle = document.getElementById("closeShareProject");
            window.scratch.getProjectFile(blob => {
                //TODO 获取到项目文件
          
                window.scratch.getProjectCover(dataURL => {
                            //TODO 获取到作品截图
                      var BASE64_MARKER = ';base64,';
                      var parts;
                      var contentType;
                      var raw;
                      if (dataURL.indexOf(BASE64_MARKER) === -1) {
                        parts = dataURL.split(',');
                        contentType = parts[0].split(':')[1];
                        raw = decodeURIComponent(parts[1]);
                        return new Blob([raw], {type: contentType});
                      }
                      parts = dataURL.split(BASE64_MARKER);
                      contentType = parts[0].split(':')[1];
                      raw = window.atob(parts[1]);
                      var rawLength = raw.length;
                      var uInt8Array = new Uint8Array(rawLength);
                      for (var i = 0; i < rawLength; ++i) {
                        uInt8Array[i] = raw.charCodeAt(i);
                      }
                      var cover = new Blob([uInt8Array], {type: contentType});
                   
                      
                      var uploadurl;
                    //设置BLOG转化为文件
                    var file = new File([blob], Filedata.filetitle, {type: "", lastModified: Date.now()});
                    const updateurl=window.scratchConfig.localhost+"/scratch/files/released"
                    //设置转化为FORMDATA提交
                    var tempdata=new FormData();
                    tempdata.append("scratch",file);
                    tempdata.append("covers",cover);
                    tempdata.append("filetitle",Filedata.filetitle);
                    tempdata.append("fileabstract",Filedata.fileabstract);
                    tempdata.append("fileexplain",Filedata.fileexplain);
                    tempdata.append("tags",Filedata.tags);
                    tempdata.append("fileonly",Filedata.fileonly);
                    tempdata.append("isContest",Filedata.isContest?1:0);
                    tempdata.append("contestNum",window.scratchConfig.contestNum|| 0);
                    tempdata.append("userid",window.scratchConfig.userID);
                    
                    fetch(updateurl,{
                         method: 'POST',
        
                       body:tempdata,
                    }) .then((response) => {
                                isSending = false;
                                return response.json()
                        }).then((res) => {
                            if(res.status == 'success'){
                                alert("发布成功，等待老师审核通过");
                                rootEle.click();
                            }
                            else
                            {
                                alert(res.msg);
                                rootEle.click();
                            }
                        }).catch((error) => {
                                alert(error);
                        })

                })
            })
        }
    }

};





const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
    //userLogin: () => dispatch(userLogined()),
    onCanel: () => dispatch(closeShareProject()),
});


export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(ShareProjectModal));

var tags = [0,0,0,0,0,0];
var tagst = ['b','c','d','e','f','c'];

const Filedata={
    filetitle:"",
    fileabstract:"",
    fileexplain:"",
    tags:"",
    fileonly:false,
    isContest:false,
}

